import { capture } from './analytics.js';

const SW_URL = '/sw.js';

function isSupported() {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}

let registered = false;

export function registerServiceWorker() {
  if (registered) return Promise.resolve(null);
  if (!isSupported()) return Promise.resolve(null);

  registered = true;

  // Snapshot whether this page is already controlled by an SW. The first
  // SW install on an uncontrolled page also fires `controllerchange` (sw.js
  // calls clients.claim() on activate); without this guard that first-install
  // event would be counted as `pwa_sw_updated`, inflating the metric.
  const hadController = !!(navigator.serviceWorker && navigator.serviceWorker.controller);

  // Attach `controllerchange` BEFORE register() so a fast activation on a
  // returning user (cached SW already installed) can't fire between
  // register() and its promise resolving — that race would silently drop
  // the pwa_sw_updated event.
  if (typeof navigator.serviceWorker.addEventListener === 'function') {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController) return;
      try {
        capture('pwa_sw_updated', {});
      } catch {
        /* analytics errors must not break SW lifecycle */
      }
    });
  }

  const run = () =>
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => registration)
      .catch((err) => {
        try {
          capture('pwa_sw_registration_failed', { message: String(err && err.message || err) });
        } catch { /* ignore */ }
        return null;
      });

  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    return new Promise((resolve) => {
      if (document.readyState === 'complete') {
        run().then(resolve);
      } else {
        window.addEventListener('load', () => run().then(resolve), { once: true });
      }
    });
  }

  return run();
}

export function _resetForTests() {
  registered = false;
}
